import { Pipe, PipeTransform } from "@angular/core";
import { RouteState } from "../../entity/enums";
import { Routes } from "../../models/kpi-details";

@Pipe({
    name: "mainkpiItemProgress",
    standalone: false
})
export class MainkpiItemProgressPipe implements PipeTransform {
  transform(kpiData: Routes, itemType: "letter" | "parcel" | "pallet") {
    const item = kpiData?.kpi?.items?.[itemType];

    const state = kpiData.route_state.toLowerCase();

    let numerator = 0;
    let denominator = item.total || 0;

    if (state === RouteState.Onroute || state === RouteState.Completed) {
      numerator = item.completed || 0;
    } else if (
      state === RouteState.Loading ||
      state === RouteState.Finishloading
    ) {
      numerator = item.loaded || 0;
    }
    const result = `${numerator} / ${denominator}`;
    return result;
  }
}
